import { getMethod } from "../../api-service/api-service";
import { setPrograms } from "./programsSlice";

export const fetchProgramsApi = () => async (dispatch) => {
    try {
        const response = await getMethod("/programs/");
        if (response.success === true) {
            dispatch(setPrograms(response?.programs));
        }
        return response;
    } catch (error) {
        console.log("Error: ", error);
        return { success: false, message: error };
    }
} 